




























import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import GroupNode1 from "./groupNode1/groupNode1.vue"
import Node from "../node/node.vue"

import Down from "../resources/down.vue";
import Right from "../resources/right.vue";

@Component({
  components: {
      GroupNode1,
      "NodeView" : Node,
      Down,
      Right
    }
})
export default class GroupNode extends Vue 
{
    @Prop() node! : any;
    @Prop() selectedNode! : any;
    @Prop() hierarchy! : number;

    select(id){
        this.$emit("select" , id)
    }

    open(id){
        this.$emit("open" , id)
    }

    get childrenHierarchy(){
        return this.hierarchy + 1;
    }
    
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigBackgroundColor(){
        var style = {};
        if(this.node.id == this.selectedNode.id){
            style = {
                position: "relative",
                display: "table",
                width: "calc(100% + " + (16 * this.hierarchy) + "px)",
                height: "25px",
                left : -16 * this.hierarchy + "px",
                backgroundColor : this.$store.getters.userConfigColors.buttonColorRgba,
                pointerEvents: "none"
            }
        }
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
